const TermsOfUse = {
  seo: {
    title: 'Terms of Use',
  },

  title: 'Terms of Use',
};

export default TermsOfUse;
